import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { RollesService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [RollesService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class RollesServiceModule {}
